import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { money } from "@/lib/api";
import { StatusBadge } from "@/components/shared";
import { ClipboardList, ChevronRight } from "lucide-react";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/orders").then((r) => { setOrders(r.data); setLoading(false); }); }, []);

  if (loading) return <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-24 rounded-2xl bg-muted animate-pulse" />)}</div>;

  if (orders.length === 0) return (
    <div className="text-center py-24">
      <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mx-auto mb-4"><ClipboardList className="w-7 h-7 text-muted-foreground" /></div>
      <h2 className="text-xl font-display font-bold">No orders yet</h2>
      <Link to="/app" className="text-brand text-sm font-medium mt-2 inline-block">Start shopping →</Link>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <h1 className="text-2xl font-display font-bold">Your orders</h1>
      {orders.map((o) => (
        <Link key={o.id} to={`/app/orders/${o.id}`} data-testid={`order-${o.id}`}
          className="flex items-center gap-4 rounded-2xl border bg-card p-4 hover:shadow-md hover:border-brand/40 transition-all">
          <div className="w-12 h-12 rounded-xl bg-muted overflow-hidden shrink-0">{o.items?.[0]?.image && <img src={o.items[0].image} alt="" className="w-full h-full object-cover" />}</div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2"><span className="font-semibold text-sm truncate">{o.store_name}</span><StatusBadge status={o.status} /></div>
            <div className="text-xs text-muted-foreground mt-0.5">{o.items?.length} item(s) · {new Date(o.created_at).toLocaleDateString()}</div>
          </div>
          <div className="text-right"><div className="font-display font-bold">{money(o.total, o.currency)}</div></div>
          <ChevronRight className="w-4 h-4 text-muted-foreground" />
        </Link>
      ))}
    </div>
  );
}
